import * as React from "react";
import "./FeatureBubbles.scss";
import {IFeature} from "../OverviewScreen";
import {TimelineMax} from "gsap/TimelineMax";
import {TweenMax} from "gsap/TweenMax";
import {Back, Linear} from "gsap/EasePack";

export interface FeatureBubblesProps {
    feature: IFeature,
    index: number,
    active: boolean,
    visible: boolean,
    fadeInProgress: number,
    mouseEventHandler: (e: any, feature: IFeature) => void;
}

export class FeatureBubbles extends React.Component<FeatureBubblesProps, {}> {

    fadeInAnimationTL: TimelineMax;

    state = {
        autoAlpha: 0,
        scale: .5,
    };

    stateAnimationProxy: any = {
        autoAlpha: 0,
        scale: 0,
    };

    constructor(props: any, context?: any) {
        super(props, context);

        this.fadeInAnimationTL = new TimelineMax();
        this.fadeInAnimationTL.to(this.stateAnimationProxy, 1, {
            scale: 1,
            autoAlpha: 1,
            ease: Back.easeOut.config(6),
            onComplete: this.stateAnimationProxySynchronize,
            onUpdate: this.stateAnimationProxySynchronize
        });
        this.fadeInAnimationTL.pause();
    }

    stateAnimationProxySynchronize = () => {
        this.setState(
            this.stateAnimationProxy
        );

        this.updateVisibleAnimationState();
    };

    componentWillReceiveProps(nextProps: FeatureBubblesProps): void {
        if ((nextProps.active != this.props.active || nextProps.visible != this.props.visible) && nextProps.fadeInProgress >= 1) {
            if (nextProps.active || nextProps.visible) {
                this.addHighlightNorShow(nextProps.active, nextProps.visible);
            } else {
                this.removeHighlightNorHide(nextProps.active, nextProps.visible);
            }
        }
        if (nextProps.fadeInProgress != this.props.fadeInProgress) {
            this.fadeInAnimationTL.progress(this.props.fadeInProgress);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // only animation will be done
        // because this will be controlled by gsap, no rerender is needed
        return false;
    }

    addHighlightNorShow = (active, visible): void => {
        const DUR: number = .3 * 1.5;

        TweenMax.to(this.stateAnimationProxy, DUR,
            {
                autoAlpha: (visible) ? 1 : 0,
                scale: (visible) ? (active) ? 1.5 : 1 : .45,
                ease: Back.easeOut.config(3),
                onComplete: this.stateAnimationProxySynchronize,
                onUpdate: this.stateAnimationProxySynchronize
            }
        );
    };

    removeHighlightNorHide = (active, visible): void => {
        const DUR: number = .15;

        TweenMax.to(this.stateAnimationProxy, DUR,
            {
                autoAlpha: (visible) ? 1 : 0,
                scale: (visible) ? (active) ? 1.5 : 1 : .45,
                ease: Linear.easeInOut,
                onComplete: this.stateAnimationProxySynchronize,
                onUpdate: this.stateAnimationProxySynchronize
            }
        );
    };

    /**
     * Keep animation state as it should be via TweenMax updates
     */
    updateVisibleAnimationState = () => {
        TweenMax.set('.FeatureBubbles.bubble-' + this.props.index, {
            autoAlpha: this.state.autoAlpha,
            scale: this.state.scale
        });
    };

    render() {
        const bubbleStyles: any = {
            left: this.props.feature.$.x + 'px',
            top: this.props.feature.$.y + 'px',
        };

        this.updateVisibleAnimationState();

        return <svg viewBox="0 0 68 68" width={68} height={68}
                    style={bubbleStyles} className={'FeatureBubbles bubble-' + this.props.index}
                    onClickCapture={(e) => this.props.mouseEventHandler(e, this.props.feature)}
                    onMouseOverCapture={(e) => this.props.mouseEventHandler(e, this.props.feature)}
                    onMouseOutCapture={(e) => this.props.mouseEventHandler(e, this.props.feature)}
                    onTouchStartCapture={(e) => this.props.mouseEventHandler(e, this.props.feature)}
                    onTouchEndCapture={(e) => this.props.mouseEventHandler(e, this.props.feature)}
        >
            <circle className="st1" cx="34" cy="34" r="34" fill={'#44407A'} opacity={0.3}/>
            <circle className="st1" cx="34" cy="34" r="19" fill={'#44407A'}/>
            <circle className="st2" cx="34" cy="34" r="6" fill={'#FFFFFF'}/>
        </svg>;
    }
}
